export const ADVICES_URL = 'advices';
export const ARTICLES_URL = 'articles';
export const CHAT_URL = 'chat';
export const EXPERT_URL = 'resql-expert';
export const EXPERT_ADMIN_URL = 'resql-expert-admin';
export const INSTRUCTIONS_URL = 'instructions';
export const INTERVENTION_PLANS_URL = 'intervention-plans';
export const MOVIES_URL = 'movies';
export const NOTICES_URL = 'notices';
export const PROFILE_URL = 'profile';
export const REPORTS_URL = 'reports';
export const RESET_PASSWORD_URL = 'reset-password';
export const SCHOOLS_URL = 'schools';
export const SET_PASSWORD_URL = 'set-password';
export const USERS_URL = 'users';
